import React, { Component } from 'react';

export default class SongKickTourBox extends Component {
  render() {
    return (
      <div className="SongKickTourBox">
        <a href="https://www.songkick.com/artists/9737459" 
           className="songkick-widget lozad" 
           data-theme="dark" 
           data-detect-style="true" 
           data-background-color="transparent"
           data-font-color="#0F3A4E">
           Moose Almighty Upcoming Shows</a>
      </div>    
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Media/SongKickTourBox/SongKickTourBox.js